import { render, staticRenderFns } from "./TheListeCommandesPage.vue?vue&type=template&id=9a96582a&scoped=true&"
import script from "./TheListeCommandesPage.vue?vue&type=script&lang=js&"
export * from "./TheListeCommandesPage.vue?vue&type=script&lang=js&"
import style0 from "./TheListeCommandesPage.vue?vue&type=style&index=0&id=9a96582a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a96582a",
  null
  
)

component.options.__file = "TheListeCommandesPage.vue"
export default component.exports